<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import { http } from '@/helpers/easyindustriaapi/config'

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      roles: [], permissions: [], selectedRoleId: null, selectedPermissions: [],
      loading: false, saving: false, newRole: { name: '', description: '' },
      items: [{ text: 'Dashboard', href: '/' }, { text: 'Usuários', active: true }]
    }
  },
  computed: {
    selectedRole() { return this.roles.find(role => Number(role.id) === Number(this.selectedRoleId)) || null },
    permissionGroups() {
      return this.permissions.reduce((groups, permission) => {
        const group = permission.name.split('.')[0]
        if (!groups[group]) groups[group] = []
        groups[group].push(permission)
        return groups
      }, {})
    }
  },
  watch: { selectedRoleId() { this.syncSelectedPermissions() } },
  async mounted() { await this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const response = await http.get('/permissions/roles')
        this.roles = response.data.roles || []
        this.permissions = response.data.all_permissions || []
        if (this.roles.length && !this.selectedRoleId) this.selectedRoleId = this.roles[0].id
        this.syncSelectedPermissions()
      } finally { this.loading = false }
    },
    syncSelectedPermissions() {
      const role = this.selectedRole
      this.selectedPermissions = role ? role.permissions.map(permission => Number(permission.id)) : []
    },
    isChecked(id) { return this.selectedPermissions.includes(Number(id)) },
    toggle(id) {
      id = Number(id)
      this.selectedPermissions = this.isChecked(id)
        ? this.selectedPermissions.filter(item => item !== id)
        : this.selectedPermissions.concat(id)
    },
    async save() {
      if (!this.selectedRole || ['super', 'admin'].includes(this.selectedRole.name)) return
      this.saving = true
      try {
        const response = await http.put(`/permissions/role/${this.selectedRole.id}`, { permissions: this.selectedPermissions })
        const index = this.roles.findIndex(role => role.id === this.selectedRole.id)
        if (index >= 0) this.$set(this.roles, index, response.data.role)
        this.$bvToast.toast('Permissões atualizadas.', { variant: 'success', solid: true })
      } finally { this.saving = false }
    },
    async createRole() {
      if (!this.newRole.name || !this.newRole.description) return
      const response = await http.post('/permissions/role', { ...this.newRole, permissions: [] })
      this.roles.push(response.data.role)
      this.selectedRoleId = response.data.role.id
      this.newRole = { name: '', description: '' }
    },
    async removeRole() {
      if (!this.selectedRole || !window.confirm('Excluir este perfil?')) return
      await http.delete(`/permissions/role/${this.selectedRole.id}`)
      this.roles = this.roles.filter(role => role.id !== this.selectedRole.id)
      this.selectedRoleId = this.roles.length ? this.roles[0].id : null
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader title="Perfis e permissões" :items="items" />
    <div class="row">
      <div class="col-md-4"><div class="card"><div class="card-body">
        <h5>Perfis</h5>
        <b-list-group>
          <b-list-group-item v-for="role in roles" :key="role.id" button :active="role.id === selectedRoleId" @click="selectedRoleId = role.id">
            <strong>{{ role.description }}</strong><br><small>{{ role.name }}</small>
          </b-list-group-item>
        </b-list-group>
        <hr><h6>Novo perfil</h6>
        <b-form-input v-model="newRole.name" placeholder="Nome técnico" class="mb-2" />
        <b-form-input v-model="newRole.description" placeholder="Descrição" class="mb-2" />
        <b-button variant="outline-primary" size="sm" @click="createRole">Criar perfil</b-button>
      </div></div></div>
      <div class="col-md-8"><div class="card"><div class="card-body">
        <div v-if="loading" class="text-center"><b-spinner /></div>
        <template v-else-if="selectedRole">
          <div class="d-flex justify-content-between align-items-center mb-3"><div><h5 class="mb-0">{{ selectedRole.description }}</h5><small>{{ selectedRole.name }}</small></div>
            <div><b-button v-if="!['super','admin'].includes(selectedRole.name)" variant="primary" :disabled="saving" @click="save">Salvar</b-button><b-button v-if="!['super','admin','user'].includes(selectedRole.name)" variant="outline-danger" class="ml-2" @click="removeRole">Excluir</b-button></div>
          </div>
          <b-alert v-if="['super','admin'].includes(selectedRole.name)" show variant="info">Este perfil é protegido e só pode ser alterado pelo fluxo administrativo apropriado.</b-alert>
          <div v-for="(group, name) in permissionGroups" :key="name" class="border rounded p-3 mb-2"><h6 class="text-uppercase">{{ name }}</h6>
            <b-form-checkbox v-for="permission in group" :key="permission.id" :checked="isChecked(permission.id)" :disabled="['super','admin'].includes(selectedRole.name)" @change="toggle(permission.id)" class="mb-1">{{ permission.description }} <small class="text-muted">({{ permission.name }})</small></b-form-checkbox>
          </div>
        </template>
      </div></div></div>
    </div>
  </Layout>
</template>
